import AbstractGeoLoc from '@phoenix/components/AbstractGeoLoc';
import { showModal } from '@phoenix/helpers/modal-helper';

export default class GeoLoc extends AbstractGeoLoc {
  shouldShowBanner(countryCodeFromIP): boolean {
    return super.shouldShowBanner(countryCodeFromIP) && countryCodeFromIP !== 'INT';
  }

  showPropositionBanner(): void {
    showModal('country-proposition-banner');
  }
}
